var map = {
	"./9e fußball.svg": 174,
	"./Santa_hat.svg": 821,
	"./conference-other.svg": 802,
	"./conference.svg": 955,
	"./elternzeit.svg": 772,
	"./grundriss-oben.svg": 915,
	"./grundriss-unten.svg": 113,
	"./homeoffice.svg": 20,
	"./other.svg": 793,
	"./sick.svg": 191,
	"./vacation.svg": 564
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 567;